import { render, staticRenderFns } from "./resume-language.vue?vue&type=template&id=4f7d9f00&"
import script from "./resume-language.vue?vue&type=script&lang=js&"
export * from "./resume-language.vue?vue&type=script&lang=js&"
import style0 from "./resume-language.vue?vue&type=style&index=0&id=4f7d9f00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports